<div *ngIf="isAuthenticated() && selectedAccount() as account; else dummy_menu">
    <div>
        <a [routerLink]="['/']">
            <img class="logo" alt="forti-cloud-logo"
                [src]="sanitizer.bypassSecurityTrustUrl('data:image/svg+xml;base64,' + account.logo)">
        </a>
        <div *ngIf="account.serviceHasItems" class="menu-container services no-select" #services
            (click)="forceServices($event)">
            <i class="service"></i> Services<i class="arrow-down"></i>
            <div [hidden]="open() !== services" class="dropdown">
                <div class="portal-col">
                    <div *ngFor="let menuHeader of account.serviceMenu; let isLast = last; let index = index"
                        [hidden]="!menuHeader.hasItems" [ngClass]="{'right-col': isLast}">
                        <div class="menu-header">{{ menuHeader.displayName }}</div>
                        <form method="POST" (ngSubmit)="onSubmit($event)" class="menu-body bi-column">
                            <div class="list-container">
                                <div class="list-item"
                                    *ngFor="let portalMenuItem of serviceMenuDisplay(menuHeader.items, index)"
                                    [title]="portalMenuItem.description">
                                    <button (click)="selectPortal(portalMenuItem, $event)" class="service-menu-button"
                                        [class.disabled-menu-button]="portalMenuItem.visibility === 'ShowDisabled'">
                                        <span>{{ portalMenuItem.displayName }}</span>
                                    </button>
                                </div>
                            </div>
                            <input type="hidden" name="h_key" [value]="fortifiedHKeyData">
                        </form>
                        <div *ngIf="isLast" class="show-more" (click)="toggle($event)">
                            <span>Show {{ isServiceMenuCollapsed() ? 'More' : 'Less'}}</span>
                            <i class="icon fontello-icon"
                                [ngClass]="isServiceMenuCollapsed() ? 'icon-arrowlightdown' : 'icon-arrowlightup'"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="account.supportHasItems" class="menu-container support no-select" #support (click)="forceSupport($event)">
            Support<i class="arrow-down"></i>
            <div [hidden]="open() !== support" class="dropdown">
                <div class="portal-col">
                    <div *ngFor="let menuHeader of account.supportMenu" [hidden]="!menuHeader.hasItems"
                        class="downloads">
                        <div class="menu-header">
                            <form method="POST" (ngSubmit)="onSubmit($event)">
                                <button (click)="selectedPortal.set(menuHeader)" class="support-menu-header-button">
                                    <span>{{ menuHeader.displayName }}</span>
                                </button>
                                <input type="hidden" name="h_key" [value]="fortifiedHKeyData">
                            </form>
                        </div>
                        <form method="POST" (ngSubmit)="onSubmit($event)" class="menu-body mono-column">
                            <div class="list-container">
                                <div class="list-item" *ngFor="let portalMenuItem of menuHeader.items"
                                    [title]="portalMenuItem.description">
                                    <button (click)="selectedPortal.set(portalMenuItem)" class="support-menu-button"
                                        [class.disabled-menu-button]="portalMenuItem.visibility === 'ShowDisabled'">
                                        <span>{{ portalMenuItem.displayName }}</span>
                                    </button>
                                </div>
                            </div>
                            <input type="hidden" name="h_key" [value]="fortifiedHKeyData">
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div>
        <div *ngIf="orgNodes()?.length > 0" class="menu-container org no-select" #org
            (click)="forceOrgDropdown()">
            <i class="icon fontello-icon icon-doc"></i>
            {{ account.details.selectedNode.email }} <i class="arrow-down"></i>
            <div [hidden]="open() !== org" class="dropdown">
                <div class="org-selector">
                    <zf-org-chooser [orgNodes]="orgNodes()" [withTitle]="false" [withSearch]="false"
                        [isLarge]="true"></zf-org-chooser>
                </div>
            </div>
        </div>
        <div class="menu-container user no-select" #user (click)="forceUserDropdown()">
            {{userId()}} <i class="arrow-down"></i>
            <div [hidden]="open() !== user" class="dropdown">
                <div class="account-info">
                    <div id="user-information">
                        <div class="user-info-item" *ngFor="let info of account.details.userDisplayInfo">
                            <span class="field">{{info.name}}</span>
                            <span class="value">{{info.value}}</span>
                        </div>
                    </div>
                    <div class="user-menu">
                        <form method="POST" (ngSubmit)="onSubmit($event)" class="menu-body mono-column">
                            <div>
                                <button *ngFor="let userMenuItem of account.userMenu"
                                    (click)="selectedPortal.set(userMenuItem)" class="user-menu-button"
                                    [class.disabled-menu-button]="userMenuItem.visibility === 'ShowDisabled'">
                                    <img class="image-container"
                                        [src]="sanitizer.bypassSecurityTrustUrl('data:image/svg+xml;base64,' + userMenuItem.imageContent)">
                                    <span>{{ userMenuItem.displayName }}</span>
                                </button>
                            </div>
                            <input type="hidden" name="h_key" [value]="fortifiedHKeyData">
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<ng-template #dummy_menu>
    <div>
        <div>
            <a [routerLink]="['/']">
                <img src="assets/logos/forticloud-topbar-icon-v4.svg" class="logo" alt="forti-cloud-logo">
            </a>
        </div>
        <div class="menu-container user" #user (click)="forceUserDropdown()">
            {{userId()}} <i class="arrow-down"></i>
            <div [hidden]="open() !== user" class="dropdown default">
                <form method="POST" (ngSubmit)="onSubmit($event)" class="menu-body mono-column">
                    <div>
                        <button (click)="defaultLogout()" class="user-menu-button">
                            <img class="image-container"
                                src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzMiAzMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzIgMzI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHRpdGxlPmNoZWNrRW50PC90aXRsZT4KPGc+Cgk8cGF0aCBkPSJNMjMuMiw3LjRjLTAuOC0wLjYtMS45LTAuNC0yLjUsMC40Yy0wLjYsMC44LTAuNCwxLjksMC40LDIuNWMyLjMsMS43LDMuNiw0LjMsMy42LDcuMWMwLDQuOS00LDguOC04LjgsOC44CgkJYy00LjksMC04LjgtNC04LjgtOC44YzAtMi44LDEuNC01LjUsMy42LTcuMWMwLjgtMC42LDEtMS43LDAuNC0yLjVjLTAuNi0wLjgtMS43LTEtMi41LTAuNGMtMy4yLDIuMy01LjEsNi4xLTUuMSwxMAoJCWMwLDYuOSw1LjYsMTIuNSwxMi41LDEyLjVjNi45LDAsMTIuNS01LjYsMTIuNS0xMi41QzI4LjMsMTMuNSwyNi40LDkuOCwyMy4yLDcuNCIvPgoJPHBhdGggZD0iTTE1LjksMTUuMmMxLDAsMS45LTAuOCwxLjktMS45VjMuN2MwLTEtMC44LTEuOS0xLjktMS45Yy0xLDAtMS45LDAuOC0xLjksMS45djkuNkMxNCwxNC40LDE0LjksMTUuMiwxNS45LDE1LjIiLz4KPC9nPgo8L3N2Zz4K">
                            <span>Logout</span>
                        </button>
                    </div>
                    <input type="hidden" name="h_key" [value]="fortifiedHKeyData">
                </form>
            </div>
        </div>
    </div>
</ng-template>
